export const PROD_SERVICE_URL = 'https://widget-data.service.elfsight.com';
export const STAGE_SERVICE_URL = 'https://widget-data-stage.elfsight.dev';

export const SERVICE_URL = PROD_SERVICE_URL;

export const meta = {
  paymentServiceUrl: `${SERVICE_URL}/api/payments`
};
